
import Vue from 'vue'
import Button from '@/components/Button.vue'
import TextField from '@/components/TextField.vue'
import AccessInfoSection from '@/components/ConsentGrantPage/AccessInfoSection.vue'
import CompanyCard from '@/components/ConsentGrantPage/CompanyCard.vue'
import ConsentAgreement from '@/components/ConsentGrantPage/ConsentAgreement.vue'

export interface ConsentForm {
	signatoryNpwp: string
	authKey: string
	agreeTc: boolean
}

export default Vue.extend({
	name: 'ConsentRequestForm',
	components: {
		Button,
		TextField,
		AccessInfoSection,
		CompanyCard,
		ConsentAgreement
	},
	props: {
		companyName: { type: String, required: true },
		companyNpwp: { type: String, required: true },
		requesterName: { type: String, required: true },
		serviceName: { type: String, required: true },
		form: {
			type: Object as () => ConsentForm,
			required: true
		},
		formErrors: {
			type: Object as () => Record<string, string>,
			default: () => ({})
		},
		submitLoading: { type: Boolean, default: false },
		canSubmit: { type: Boolean, default: false },
		serviceLearnMoreUrl: { type: String, required: true },
		authKeyLearnUrl: { type: String, required: true }
	},
	computed: {
		signatoryNpwpError(): string {
			const signatoryNpwp = this.form.signatoryNpwp.trim()
			if (signatoryNpwp && signatoryNpwp.length < 15) {
				return this.$t('errors.npwp__min_length') as string
			}

			return this.formErrors.signatoryNpwp || ''
		}
	},
	methods: {
		sanitizeNumeric(value: string): string {
			return (value || '').replace(/[^\d]/g, '')
		},
		updateForm(patch: Partial<ConsentForm>) {
			const nextPatch = { ...patch }
			if (typeof nextPatch.signatoryNpwp === 'string') {
				nextPatch.signatoryNpwp = this.sanitizeNumeric(nextPatch.signatoryNpwp)
			}
			this.$emit('update:form', { ...this.form, ...nextPatch })
		}
	}
})
